import { memo } from 'react';

import * as Styled from './styled/HeroTitle';

type HeroTitleProps = {
  kind: 'primary' | 'light';
  heroTitle: string;
  downgradeHeadingLevels: boolean;
}

const HeroTitle = ({ downgradeHeadingLevels = false, heroTitle, kind }: HeroTitleProps) => {
  if (downgradeHeadingLevels) return <Styled.TitleH2Styled $kind={kind} $removeBackground>{heroTitle}</Styled.TitleH2Styled>;
  return <Styled.TitleH1Styled $kind={kind} $removeBackground>{heroTitle}</Styled.TitleH1Styled>;
};

export default memo(HeroTitle);
